<script setup lang="ts">
import {
    reactive, type UnwrapRef,
} from 'vue';
import { useQuasar } from 'quasar';
import type { CardSegment } from '@/types/CardSegment';

const props = defineProps<{
    cardSegments: CardSegment[],
}>();

const $q = useQuasar();

const cardSegments: UnwrapRef<CardSegment[]> = reactive(props.cardSegments);

</script>
<template>
    <q-card-section
        :horizontal="$q.screen.gt.sm"
        class="segment-container justify-between row"
    >
        <q-card-section
            v-for="(segment, index) in cardSegments"
            :key="index"
            class="row segment q-pa-md"
        >
            <div
                class="col-auto big-icon q-pa-sm"
                :class="($q.screen.xs || $q.screen.md) ? 'q-mr-sm' : 'q-mr-lg'"
            >
                <q-icon
                    class="text-weight-bold"
                    :name="segment.iconName"
                />
            </div>
            <div
                class="col info-content"
            >
                <div class="row">
                    <div class="col-12">
                        <span class="info-text-small">
                            {{ segment.description }}
                        </span>
                    </div>
                    <div class="col-12">
                        <span
                            class="info-text-big"
                        >
                            {{ segment.content }}
                        </span>
                    </div>
                </div>
            </div>
        </q-card-section>
    </q-card-section>
</template>
<style scoped lang="scss">
.segment-container {
    gap: 30px;

    .segment {
        background: var(--fsum-light-blue);
        border-radius: 4px;
        width: 100%;
    }
}
.big-icon {
    font-size: 25px;
    background: #99c2eb;
    border: 2px solid #99c2eb;
    border-radius: 5px;
    height: fit-content;
    width: fit-content;

    @media screen and (max-width: $breakpoint-md-min) {
        font-size: 20px;
    }
}
.info-text-small {
    font-size: 14px;
    color: var(--fsum-med-gray);
}
.info-text-big {
    font-size: 30px;
    font-weight: 700;
    word-wrap: break-word;

    @media screen and (max-width: $breakpoint-md-max) {
        font-size: 23px;
    }
}
:deep(.small-icon.q-icon) {
    color: #9D9D9D;
    font-size: 20px;
}
:deep(.q-btn) {
    padding-bottom: 20px;
}
</style>
